<div class="custom-table overflow-x-auto mt-[24px]">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					*ngIf="walletFilter.activeTab == 0"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'WALLET.WALLET_LIST.ORGSNAME' | translate }}
				</td>
				<td
					*ngIf="walletFilter.activeTab == 0"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'WALLET.WALLET_LIST.BRANCHNAME' | translate }}
				</td>
				<td
					*ngIf="walletFilter.activeTab == 0"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'WALLET.WALLET_LIST.WALLET_BALANCE' | translate }}
				</td>
				<td
					*ngIf="walletFilter.activeTab == 1"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'WALLET.WALLET_LIST.CLIENT' | translate }}
				</td>
				<td
					*ngIf="walletFilter.activeTab == 1"
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'WALLET.WALLET_LIST.WALLET_BALANCE' | translate }}
				</td>
				<td></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background" *ngIf="walletFilter?.activeTab == 0">
			<tr
				*ngFor="
					let wallet of spWallets
						| paginate
							: {
									itemsPerPage: walletFilter?.paging?.pageSize,
									currentPage: walletFilter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
				class="{{
					indx + 1 != spWallets?.length
						? 'border-b-[1px] border-secondry-color-Gray'
						: ''
				}}"
			>
				<td
					(click)="viewDetails(wallet)"
					class="cursor-pointer text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{
						translate.currentLang === 'ar'
							? wallet?.branchName
							: wallet?.branchName
					}}
				</td>

				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular"
				>
					{{
						translate.currentLang === 'ar'
							? wallet?.providerName
							: wallet?.providerName
					}}
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<h1 class="text-font-16 text-dark-grey mb-0">
						{{ wallet.walletAmount }}
						{{
							translate.currentLang == 'en'
								? wallet.currency.name.en
								: wallet.currency.name.ar
						}}
					</h1>
					<h1 class="text-font-14 text-dark-grey mb-0">
						{{ 'WALLET.SP_WALLET.HOLD_AMOUNT' | translate }}

						{{ wallet?.walletHoldAmount }}
						{{
							translate?.currentLang == 'en'
								? wallet?.currency?.name?.en
								: wallet?.currency?.name?.ar
						}}
					</h1>
				</td>

				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span class="inline-block max-mobile:w-[20px] w-[16px] text-end">
						<img
							(click)="viewDetails(wallet)"
							[src]="'assets/images/view.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</span>
				</td>
			</tr>
		</tbody>
		<tbody class="bg-grey-background" *ngIf="walletFilter?.activeTab == 1">
			<tr
				*ngFor="
					let wallet of clientWallets
						| paginate
							: {
									itemsPerPage: walletFilter?.paging?.pageSize,
									currentPage: walletFilter?.paging?.pageNumber,
									totalItems: totalCountClient
							  };
					let indx = index
				"
				class="{{
					indx + 1 != spWallets?.length
						? 'border-b-[1px] border-secondry-color-Gray'
						: ''
				}}"
			>
				<td
					*ngIf="walletFilter.activeTab == 1"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ wallet?.clientName }}
				</td>
				<td
					*ngIf="walletFilter.activeTab == 1"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<h1 class="text-font-16 text-dark-grey mb-0">
						{{ wallet.walletAmount }}
						{{
							translate.currentLang == 'en'
								? wallet.currency.name.en
								: wallet.currency.name.ar
						}}
					</h1>
					<h1 class="text-font-14 text-medium-gray mb-0">
						{{ 'WALLET.SP_WALLET.HOLD_AMOUNT' | translate }}

						{{ wallet?.walletHoldAmount }}
						{{
							translate?.currentLang == 'en'
								? wallet?.currency?.name?.en
								: wallet?.currency?.name?.ar
						}}
					</h1>
				</td>
				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span class="inline-block max-mobile:w-[20px] w-[16px] text-end">
						<img
							(click)="viewDetails(wallet)"
							[src]="'assets/images/view.svg'"
							alt=""
							class="inline-block cursor-pointer"
						/>
					</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>
